var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.684,
    height: 98.825,
    viewBox: "0 0 141.684 98.825",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2341",
    "data-name": "Groupe 2341",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2880",
    "data-name": "Trac\\xE9 2880",
    d: "M77.762,63.743,81.61,75.756a3.611,3.611,0,0,1-.444,3.133,3.393,3.393,0,0,1-2.738,1.5,3.238,3.238,0,0,1-1.653-.493L59.582,69.663q-2.294.222-4.588.222a41.417,41.417,0,0,1-9.423-.937,42.443,42.443,0,0,0,8.56-25.136,43.6,43.6,0,0,0-.444-5.673,41.872,41.872,0,0,0-1.184-5.55A42.471,42.471,0,0,0,38.689,11.473,52.224,52.224,0,0,0,31.708,6.49,43.106,43.106,0,0,1,54.994,0,43.248,43.248,0,0,1,83.361,10.166,32.682,32.682,0,0,1,95.177,34.956c0,11.52-6.512,22.275-17.415,28.787",
    transform: "translate(46.507 0)",
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2881",
    "data-name": "Trac\\xE9 2881",
    d: "M47.541,8.419l.525,0,.086,0,.086,0,.523,0A44.509,44.509,0,0,1,77.428,18.913,31.565,31.565,0,0,1,88.906,42.889,31.6,31.6,0,0,1,77.374,66.9,44.456,44.456,0,0,1,48.762,77.347l-.612,0c-1.6,0-3.209-.076-4.785-.229l-2.422-.237-2.087,1.246L25.933,85.833l1.976-6.182L29.7,74.056l-5.044-3.012C13.851,64.592,7.4,54.066,7.4,42.963A31.591,31.591,0,0,1,18.93,18.868,44.456,44.456,0,0,1,47.541,8.419m0-7.4a51.814,51.814,0,0,0-33.38,12.188A39.027,39.027,0,0,0,0,42.887C0,56.693,7.8,69.6,20.861,77.4L16.256,91.8a4.26,4.26,0,0,0,.53,3.757,4,4,0,0,0,3.273,1.776,3.829,3.829,0,0,0,2-.567L42.647,84.476c1.823.178,3.675.266,5.5.266.2,0,.407,0,.612,0a51.8,51.8,0,0,0,33.38-12.191A39.029,39.029,0,0,0,96.306,42.889,39.031,39.031,0,0,0,82.142,13.207,51.8,51.8,0,0,0,48.762,1.019l-.609,0c-.2,0-.407,0-.612,0",
    transform: "translate(0 1.495)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2882",
    "data-name": "Trac\\xE9 2882",
    d: "M29.009,16.3a4.193,4.193,0,0,0-.178,8.382c.062,0,.123,0,.185,0A4.2,4.2,0,0,0,33.2,20.67c0-.059,0-.118,0-.175A4.1,4.1,0,0,0,29.187,16.3h0c-.062,0-.121,0-.183,0",
    transform: "translate(36.403 23.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2883",
    "data-name": "Trac\\xE9 2883",
    d: "M22.5,16.3a4.193,4.193,0,0,0-.178,8.382c.062,0,.123,0,.185,0a4.2,4.2,0,0,0,4.186-4.013c0-.059,0-.118,0-.175A4.1,4.1,0,0,0,22.679,16.3h0c-.062,0-.121,0-.183,0",
    transform: "translate(26.858 23.902)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2884",
    "data-name": "Trac\\xE9 2884",
    d: "M16,16.3a4.193,4.193,0,0,0-.178,8.382c.062,0,.123,0,.185,0a4.2,4.2,0,0,0,4.186-4.013c0-.059,0-.118,0-.175A4.1,4.1,0,0,0,16.173,16.3h0c-.062,0-.121,0-.183,0",
    transform: "translate(17.315 23.902)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.93908efb52bdbbaffe8d3fc142100f59.svg";
export { ForwardRef as ReactComponent };